import React from 'react'
import { Link } from 'gatsby'
import { css } from 'emotion'
import Img from 'gatsby-image'
import { Header, Label } from 'semantic-ui-react'

export const THUMBNAIL_SIZE = `300px`
export const COLLAPSE_WIDTH = 550;

export const styles = {}
styles.postLinkContainer = css`
  .content {
    margin-bottom: 12px;
    margin-top: 12px;
    position: relative;
    display: flex;
  }
  .link-content {
    margin-left: 22px;
  }
  .gatsby-image-wrapper {
    min-width: ${THUMBNAIL_SIZE};
  }
  @media (max-width: ${COLLAPSE_WIDTH}px) {
    & > .content {
      min-height: 300px;
      display: block;
    }
    img {
      border-top-right-radius: 8px;
    }
    position: relative;
    .link-content {
      /* box-shadow: 0 0 100px 32px white inset; */
      /* background-color: rgba(255, 255, 255, 0.5); */
      box-shadow: 0 -280px 32px -32px rgba(255, 255, 255, 0.9) inset;
      margin-left: 0;
      position: absolute;
      bottom: 0;
      width: 100%;
      p, h1 {
        padding: 6px;
      }
      h1 {
        margin: 0;
        /* box-shadow: 0 -130px 32px -32px rgba(255, 255, 255, 0.85) inset; */
      }
      /* p {
        background-color: rgba(255, 255, 255, 0.85);
      } */
    }
  }
  .ui.label {
    color: #4183c4;
  }
  border-radius: 8px;
  img {
    border-top-left-radius: 8px;
  }
  .tag-container {
    padding-bottom: 32px;
    width: 100%;
    border-bottom: 1px solid grey;
    border-radius: 8px;
  }
`;

const IS_BROWSER = typeof window !== 'undefined';

export const PostLink = ({ fields, meta, excerptShort, excerpt }) => (
  <div className={styles.postLinkContainer}>
    <div className="content">
      <Img fluid={meta.thumbnail.data.fluid} />
      <div className="link-content">
        <Header as="h1">
          <Header.Content>
            <Link to={fields.slug}>{meta.title}</Link>
            <Header.Subheader>{meta.date}</Header.Subheader>
          </Header.Content>
        </Header>
        <p>
          {IS_BROWSER && (window.innerWidth <= COLLAPSE_WIDTH) ? excerptShort : excerpt}
        </p>
      </div>
    </div>
    <div className="tag-container">
      {meta.tags.map(tag => (
        <Label as="a" href={`/tags/${tag}`} key={tag} tag>
          #{tag}
        </Label>
      ))}
    </div>
  </div>
)
